import React from 'react';
import * as uuid from "uuid";

import NavigationItem from "./navigationItem";
import {UserPopupTypes} from "../constants";
import {getFeatureCost, getFeatureIsLocked, isIE} from "../../../misc/helpers";
import Walls from "../../kvComponent/core/parts/walls";
import Cabinet from "../../kvComponent/core/parts/cabinet";
import CountertopGroup from "../../kvComponent/core/parts/countertopGroup";
import CenterIsland from "../../kvComponent/core/parts/centerIsland";
import {getCurrentLayout} from "../../appLayout";
import {getBvGroupFeatures} from "../../../api/server-api";
import LoadingBar from '../../../lib/react-redux-loading-bar';
import CommonFeatureItemsMethods from "../commonFeatureItemsMethods";
import {checkIfNeedToReceiveFeaturesIfFiltersApplied} from "../../../misc/filtersFunctions";
import {
  displayMaterialsWizardGroupAsFeature,
  getMissingWizardFeatures
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getAdditionalFeaturesOnScroll} from "../../../api/look-api";
import Config from "../../../config";
import {isNavItemNotInVisualizer} from "../featuresFunctions";

export default class NavigationItemsList extends CommonFeatureItemsMethods {  // this class is used for both Desktop & Mobile navigations to avoid method's duplicating

  constructor(props) {
    window.itemClickCount = window.itemClickCount || 0;
    window.allowClickLeadCapturePopup = true;
    super(props);
  }

  componentDidMount() {
    this.reorderItems(this.props);
    const childItem = this.props.childItem && this.props.childItem.part;
    if (childItem && childItem.partId.includes("countertop") && this.props.selectedFilters.length && !this.props.activeNavigationFilter) {
      const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(this.props.selectedFilters, childItem);
      if (checkPassed) {
        this.getFeaturesFromBackendWithFilters(childItem, checkPassed.arrayOfNeededFiltersToReceive, 1);
      }
    }
  }

  itemClick = (item, featureIsLocked, event) => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    if( !this.props.userIsLoggedIn && fabricatorSettings.clickLeadCapture && (++window.itemClickCount >= fabricatorSettings.clickLeadCount) && window.allowClickLeadCapturePopup) {
      this.handleUserLoginClick(UserPopupTypes.NewDesign);
      return;
    }
    this.props.onItemClick(item, false, featureIsLocked, event);
    this.forceUpdate();
  };

  getActiveFeatureName = (uniquePartNamesArray, parentId, childName, isCabinet = false) => {
    const layout = getCurrentLayout();
    const parent = layout.parts[parentId];
    const activeFeature = parent && parent[childName] && parent[childName].activeFeature;
    if (activeFeature) {
      uniquePartNamesArray.unshift(activeFeature.getSplittedFeatureName(isCabinet))
    }
    return uniquePartNamesArray
  };

  getSelectedWallIndexes = (childItem, features, selectedFirstItemIndex) => {
    if (this.props.isWizard && this.props.currentGroups && displayMaterialsWizardGroupAsFeature(this.props.currentGroups)) {
      return []
    }
    const layout = getCurrentLayout();
    let otherSelectedWallsIndexes = [];
    let uniquePartNamesArray = [];
    const kitchenCabinetPartIds = ["top_cabinet", "bottom_cabinet", "center_island_cabinet"];
    if (childItem && childItem.part && childItem.part.isStoneFeature) {
      uniquePartNamesArray = layout.getStonesActiveFeatures().map((activeFeature) => {
        return activeFeature.cartFeature.getSplittedFeatureName()
      });
      switch (childItem.part.partId) {
        case "backsplash": {
          const parentItem = childItem.part.getParent();
          const rightWall = parentItem && parentItem.rightWall;
          if (rightWall && rightWall.activeFeature) {
            uniquePartNamesArray.unshift(rightWall.activeFeature.getSplittedFeatureName())
          }
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, CenterIsland.id, "countertop");
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, CountertopGroup.id, "countertop");
          break;
        }
        case "countertop": {
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, Walls.id, "backsplash");
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, CenterIsland.id, "countertop");
          break;
        }
        case "center_island_countertop": {
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, Walls.id, "backsplash");
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, CountertopGroup.id, "countertop");
          break;
        }
        default:
          break;
      }
    } else if (childItem && childItem.part && (kitchenCabinetPartIds.includes(childItem.part.partId))) {
      switch (childItem.part.partId) {
        case "top_cabinet": {
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, CenterIsland.id, "cabinet");
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, Cabinet.id, "bottomCabinet", true);
          break;
        }
        case "bottom_cabinet": {
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, CenterIsland.id, "cabinet");
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, Cabinet.id, "topCabinet", true);
          break;
        }
        case "center_island_cabinet": {
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, Cabinet.id, "topCabinet", true);
          uniquePartNamesArray = this.getActiveFeatureName(uniquePartNamesArray, Cabinet.id, "bottomCabinet", true);
          break;
        }
      }
    }
    // console.log("uniquePartNamesArray", uniquePartNamesArray);
    if (uniquePartNamesArray.length) {
      uniquePartNamesArray = isIE()
        ? uniquePartNamesArray.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[])
        : [...uniquePartNamesArray.reduce((p,c) => p.set(c,true),new Map()).keys()]; //remove duplicates
      // console.log('uniquePartNamesArray', uniquePartNamesArray);
      uniquePartNamesArray.forEach((uniquePartName) => {
        let foundIndex = features.findIndex(feature => feature.part && (feature.part.getSplittedFeatureName() === uniquePartName));
        if (foundIndex < 0) {
          foundIndex = features.findIndex(feature => {
            if (!feature.part) {
              return false
            }
            if (childItem.part.partId === "backsplash") {
              // example: countertop - "Dymo White 12X24 Glossy", backsplash - "Dymo White 12X24 Glossy 4in l"
              return feature.part.partName.includes(uniquePartName)
            }
            return feature.part.partName === uniquePartName
          });
        }
        if (foundIndex > -1 && selectedFirstItemIndex !== foundIndex) {
          otherSelectedWallsIndexes.push(foundIndex);
        }
      });
    }
    // console.log("otherSelectedWallsIndexes", otherSelectedWallsIndexes);
    return otherSelectedWallsIndexes
  };

  getLockedFeature = (activeFeature) => {
    const filterValues = activeFeature.part.dbFeature && activeFeature.part.dbFeature.filterValueIDs;
    if (filterValues) {
      return Object.keys(filterValues).some((filterKey) => {
        const filterGroup = this.props.filterGroups.find(group => group.id === +filterKey);
        const filterValue = filterGroup && filterGroup.values && filterGroup.values.find(value => value.id === filterValues[filterKey][0]);
        return filterValue && filterValue.lockedInWizard
      });
    }
    return false
  };

  getActiveItemIndex = (props) => {
    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    let isActiveItemIndex = null;
    if (props.childItem && props.childItem.part.activeFeature) {
      isActiveItemIndex = props.features.findIndex((item) => {
        if(item && item.part)
          return props.childItem.part.activeFeatureId(showPlaceHolders) === item.part.id()
      })
    } else if (props.parentItem.part.activeFeature) {
      isActiveItemIndex = props.features.findIndex((item) => {
        if(item && item.part)
          return props.parentItem.part.activeFeatureId(showPlaceHolders) === item.part.id()
      })
    }
    return isActiveItemIndex
  };

  getReorderedItems = (indexesToReplace, props, selectedExist = false, isQuotingTool = false) => {
    let reOrderedFeatures = props.features;
    const featuresToPlaceFirst = indexesToReplace.map(index => reOrderedFeatures[index]).reverse();
    const sorted = this.getSortedFeatures(reOrderedFeatures, selectedExist, isQuotingTool);
    featuresToPlaceFirst.forEach((navItemToReplace) => {
      const currentIndex = sorted.findIndex(navItem => navItem.part.dbFeature.id === navItemToReplace.part.dbFeature.id)
      if (currentIndex > -1) {
        sorted.splice(currentIndex, 1);
        sorted.splice(0, 0, navItemToReplace);
      }
    });
    // console.log("sorted", sorted);
    return sorted
  };

  checkForSelectedAccessories = (activeFeature, selected) => {
    const accessories = ["large_corner_caddie", "corner_caddie", "small_corner_shelf", "large_corner_seat"];
    if (accessories.includes(activeFeature.partId)) {
      if (activeFeature.partId === "large_corner_seat") {
        if (activeFeature.getParent().getParent().caddie_type === "large_corner_caddie") {
          selected = false
        }
      } else if (activeFeature.getParent().getParent().caddie_type !== activeFeature.partId) {
        selected = false
      }
    }
    return selected
  };

  getFeaturePropertyToSort = (navItem, property) => {
    if (property === "name") {
      return navItem.part.getFeatureName()
    }
    if (property === "SortPositionNum") {
      return navItem.part.metaData[property] || 99999;
    }
    return navItem.part[property];
  }

  getNavItemsSortedByProperty = (navItems, property, property2) => {
    const order = "asc";
    // console.log("navItems - navItems", navItems);
    navItems = navItems.sort((a,b) => {
      let prop1 = this.getFeaturePropertyToSort(a, property);
      let prop2 = this.getFeaturePropertyToSort(b, property);
      let prop3 = this.getFeaturePropertyToSort(a, property2);
      let prop4 = this.getFeaturePropertyToSort(b, property2);
      return order === "asc"
        ? (prop1 > prop2) ? 1 : (prop1 < prop2) ? -1 : (prop3 > prop4) ? 1 : (prop3 < prop4) ? -1 : 0
        : (prop1 < prop2) ? 1 : (prop1 > prop2) ? -1 : (prop3 < prop4) ? 1 : (prop3 > prop4) ? -1 : 0
    })
    // console.log("navItems", navItems);
    return navItems
  };

  getSortedFeatures = (features, selectedExist = false, isQuotingTool = false) => {
    if (this.props.isWizard && this.props.currentGroups && displayMaterialsWizardGroupAsFeature(this.props.currentGroups)) {
      return features
    }
    const {fabricatorData} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    let newFeatures = [...features.filter(feature => feature && feature.part && feature.part.dbFeature)];
    let selectedFeature = null;
    if (selectedExist && (!isQuotingTool || (newFeatures[0] && this.checkIfFeatureSelected(newFeatures[0].part, newFeatures[0].part.getParent())))) {
      selectedFeature = newFeatures[0];
      newFeatures.splice(0, 1);
    }
    if ((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !this.props.isPhoneNumberValidated) {
      const unLockedFeatures = newFeatures
        .filter(navItem => !getFeatureIsLocked(navItem.part))
        .map(navItem => {
          navItem.part.featurePrice = getFeatureCost(navItem.part, 1);
          return navItem
        })
      const lockedFeatures = newFeatures
        .filter(navItem => getFeatureIsLocked(navItem.part))
        .map(navItem => {
          navItem.part.featurePrice = getFeatureCost(navItem.part, 1);
          return navItem
        })
      newFeatures = fabricatorSettings.showPricing ? [
        ...this.getNavItemsSortedByProperty(unLockedFeatures, "featurePrice", "name"),
        ...this.getNavItemsSortedByProperty(lockedFeatures, "featurePrice", "name")
      ] : [...unLockedFeatures, ...lockedFeatures];
    } else if (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser) {
      newFeatures = newFeatures.map(navItem => {
        navItem.part.featurePrice = getFeatureCost(navItem.part, 1);
        return navItem
      })
      newFeatures = this.getNavItemsSortedByProperty(newFeatures, "featurePrice", "name")
    } else {
      const propertyToSort = newFeatures.some(navItem => navItem.part.metaData["SortPositionNum"]) ? "SortPositionNum" : "name";
      newFeatures = this.getNavItemsSortedByProperty(newFeatures, propertyToSort, "");
      if (!isQuotingTool && newFeatures.some(navItem => navItem.part.useMatchesFailedNavigation)) {
        newFeatures = this.getNavItemsSortedByProperty(newFeatures, "matchesMetaFailed");
      }
    }
    if (isQuotingTool) {
      // newFeatures = this.getNavItemsSortedByProperty(newFeatures, "notAvailableInVisualizer", "_customDisplayName")
      const inVisFeatures = newFeatures.filter(navFeature => !isNavItemNotInVisualizer(navFeature));
      const notInVisFeatures = newFeatures.filter(navFeature => isNavItemNotInVisualizer(navFeature));
      newFeatures = [
        ...inVisFeatures,
        // ...this.getNavItemsSortedByProperty(notInVisFeatures, "featurePrice", "name")
        ...notInVisFeatures
      ];
    }
    if (selectedExist && selectedFeature) {
      newFeatures.unshift(selectedFeature)
    }
    return newFeatures
  };

  getNavItemsList = (isMobile) => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    const elements = [];

    const features = this.state.reorderedFeatures.filter(feature => feature);
    // console.log('features', features);

    for (let i = 0; i < features.length; i++ ) {
      const currentFeature = features[i];
      const currentParent = this.props.childItem || this.props.parentItem;

      let isActive = false;
      if (((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !this.props.isPhoneNumberValidated)
        || (showPlaceHolders && currentParent.part.placeholderFeature && !currentParent.part.placeholderChanged)) {
        isActive = currentFeature && this.props.activeFeature && currentParent
          && currentParent.part.firstClick[this.props.activeQuoteIndex]
          && this.props.activeFeature.dbFeature.id === currentFeature.part.id();
      } else {
        isActive = currentFeature && this.props.activeFeature && this.props.activeFeature.dbFeature.id === currentFeature.part.id();
      }

      if (isActive) {
        isActive = this.checkForSelectedAccessories(this.props.activeFeature, isActive);
      }

      let isPulsating = false;
      if ((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !this.props.isPhoneNumberValidated
        && currentFeature && currentFeature.part.dbFeature.unlocked
        && (!this.props.activeFeature || (this.props.childItem && (!this.props.childItem.part.firstClick[this.props.activeQuoteIndex] || !this.props.activeFeature.dbFeature.unlocked)))) {
        isPulsating = true
      }

      let currentFeatureCartItemsCount = 0;
      const currentFeatureId = currentFeature && currentFeature.part.dbFeature.id;
      const matchingCartItem = this.props.cartItems.find((cartItem) => {
        return currentFeatureId === (cartItem.cartFeature.dbFeature && cartItem.cartFeature.dbFeature.id)
          && (cartItem.currentQuote === this.props.activeQuoteIndex);
      });
      if (matchingCartItem) {
        currentFeatureCartItemsCount = matchingCartItem.quantity
      }

      elements.push(
        <NavigationItem currentFeature={currentFeature}
                        isMobile={isMobile}
                        key={"navigationItem"+i}
                        stoneFeature={currentFeature && currentFeature.part && currentFeature.part.isStoneFeature}
                        customClassName={currentFeature && currentFeature.part && currentFeature.part.customClassName}
                        isActive={isActive}
                        isPulsating={isPulsating}
                        onItemClick={this.itemClick}
                        userIsLoggedIn={this.props.userIsLoggedIn}
                        isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                        handleUserLoginClick={this.handleUserLoginClick}
                        filterGroups={this.props.filterGroups}
                        switchToFeatureInfo={(currentFeature) => this.switchToFeatureInfo(
                          currentFeature, "nav-item-info-clicked", "visualizer"
                        )}
                        fabricatorData={this.props.fabricatorData}
                        largeThumbnail={!isMobile && (this.props.navigationViewType === 2)}
                        currentFeatureCartItemsCount={currentFeatureCartItemsCount}
                        existInQtCategory={this.props.existInQtCategory}
        />
      );
    }

    return elements

  };

  getLoadingFeatures = () => (
    <div className="selection-overlay">
      <div className="selection-overlay__loader">
        <div className="message-loading-left-panel message-loading-panel-settings">
          <div className="message-loading-left-panel-spinner"/>
          <LoadingBar className="message-loading-left-panel-counter"/>
        </div>
      </div>
    </div>
  );

  // onDesktopNavigationScroll = ({clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth}) => {
  onDesktopNavigationScroll = ({clientWidth, scrollLeft, scrollWidth}) => {
    // console.log("clientHeight", clientHeight);
    // console.log("clientWidth", clientWidth);
    // console.log("scrollHeight", scrollHeight);
    // console.log("scrollLeft", scrollLeft);
    // console.log("scrollTop", scrollTop);
    // console.log("scrollWidth", scrollWidth);
    // console.log("=================");
    if ((scrollWidth - Math.ceil(scrollLeft) === clientWidth) || (scrollWidth - Math.floor(scrollLeft) === clientWidth)) {
      this.getNewFeaturesOnScroll(scrollLeft);
    }
  };

  onMobileNavigationScroll = ({clientHeight, scrollHeight, scrollTop}) => {
    if ((scrollHeight - Math.ceil(scrollTop) === clientHeight) || (scrollHeight - Math.floor(scrollTop) === clientHeight)) {
      this.getNewFeaturesOnScroll(scrollTop)
    }
  };

  getFeaturesFromBackendWithFilters = (childItem, counterTopFiltersIdsReceived, finalScrollPosition = 1, existingFilterObject = null) => {
    const filterObject = existingFilterObject || {
      uuid: uuid.v4(),
      filterIds: counterTopFiltersIdsReceived, // array of arrays, ex. [[56],[1122,1313]] etc.
      featuresReceived: 0,
      page: 0
    };
    if (!existingFilterObject) {
      childItem.filterIdsReceived.push(filterObject);
    }

    const featuresCountToReceive = 5000;

    if (!this.featureReceivingStarted) {
      this.setState({
        additionalFeaturesLoading: true
      });
      this.featureReceivingStarted = true;
      getBvGroupFeatures(
        childItem.dbName || childItem.partName,
        filterObject.page,
        featuresCountToReceive,
        counterTopFiltersIdsReceived
      )
        .then((response) => {
          if (response && response.length) {
            console.log("response.data with filters", response);
            childItem.setGroupFeatures(response, featuresCountToReceive, false, "", null, true);
            childItem.filterIdsReceived = childItem.filterIdsReceived.map((filtersReceivedObject) => {
              if (filtersReceivedObject.uuid === filterObject.uuid) {
                filtersReceivedObject.featuresReceived += response.length;
                if (response.length < featuresCountToReceive) {
                  filtersReceivedObject.allFeaturesWithFiltersReceived = true;
                } else {
                  filtersReceivedObject.page++;
                }
              }
              return filtersReceivedObject
            });
          }
          this.finishScrollRequest(finalScrollPosition);
        });
    }
  };

  finishScrollRequest = (finalScrollPosition, shouldUpdateNavItems = true) => {
    this.setState({
      additionalFeaturesLoading: false
    }, () => {
      if (shouldUpdateNavItems) {
        this.needToUpdate = finalScrollPosition;
        this.props.parentUpdate();
      }
      this.featureReceivingStarted = false;
    });
  }

  getNewFeaturesOnScroll = async (finalScrollPosition, parentItemPassed = null) => {

    const {useNewWizardFeaturesRequestsLogic, wizardGroup, currentParent} = this.props;

    if (useNewWizardFeaturesRequestsLogic) {
      if (this.featureReceivingStarted || currentParent.requestInProgress) {
        return;
      }
      this.featureReceivingStarted = true;
      this.setState({
        additionalFeaturesLoading: true
      });
      getMissingWizardFeatures(this.state.reorderedFeatures, wizardGroup, currentParent)
        .then(shouldUpdateNavItems => this.finishScrollRequest(finalScrollPosition, shouldUpdateNavItems));
      return;
    }

    const parentItem = parentItemPassed || this.props.childItem || this.props.parentItem;
    if (!parentItem.part) {
      return
    }
    if (this.props.selectedFilters.length) {
      const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(this.props.selectedFilters, parentItem.part, true);
      console.log("checkPassed", checkPassed);
      if (checkPassed) {
        this.getFeaturesFromBackendWithFilters(parentItem.part, checkPassed.filterIds, finalScrollPosition, checkPassed);
      }
      return
    }
    if (!parentItem.part.getRealFeaturesReceivedProperty() && !this.featureReceivingStarted) {
      this.featureReceivingStarted = true;
      this.setState({
        additionalFeaturesLoading: true
      });

      const additionalFeaturesOnScroll = await getAdditionalFeaturesOnScroll(parentItem.part);
      if (Config.isDevMode()) {
        console.log("additionalFeaturesOnScroll", additionalFeaturesOnScroll);
      }

      this.finishScrollRequest(finalScrollPosition);
    }
  };

}
